// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__NqdV7","range":"MonthRangeSwitch_range__rJb_3","disabled":"MonthRangeSwitch_disabled__2dIpO"};